import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { guest, auth, middlewarePipeline } from './middleware';

import AuthLayout from '@/components/auth/AuthLayout'
import AppLayout from '@/components/admin/AppLayout'

import EmptyParentComponent from './router_empty';
import AuthRoutes from './router_auth';
import PageRoutes from './router_pages';
import AdminRoutes from './router_admin';

Vue.use(Router)

const router = new Router({
  
  routes: [
    
    {
      path: '*',
      redirect: { name: 'watchedItems' },
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: AuthRoutes
    },
    {
      path: '/404',
      component: EmptyParentComponent,
      children: PageRoutes
    },
    {
      name: 'Admin',
      path: '/admin',
      beforeEnter (to, from, next) {
        next()
      },
      component: AppLayout,
      meta: { middleware: [ auth ] },
      children: AdminRoutes
    },
  ],
})


/**
 * Authentication guard to be applied to routes
 * 
 * @param {string} to 
 * @param {string} from
 * @param {Function} next
 * 
 * @return {Function}
 */
router.beforeEach((to, from, next) => {
  
  if (!to.meta.middleware) { return next() }
  
  const middleware = to.meta.middleware
  const context = { to, from, next, store }
  
  return middleware[0]({
    ...context, next: middlewarePipeline(context, middleware, 1)
  })
  
})

export default router